import { Button, Container } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import PageTitle from "../../../components/pageTitle/PageTitle";
import {
  generateFirebaseId,
  generateNumberArray,
} from "../../../services/helpers";
import styles from "../Accounts.module.scss";
import { useMediaQuery } from "@mui/material";
import CommonContext from "../../../hooks/commonContext";
import AuthContext from "../../../hooks/authContext";
import {
  getSettings,
  getSuppliesCompanyCategories,
  resetSettings,
  resetSuppliesCompanyCategory,
  saveOrUpdateSuppliesCompanyCategories,
  saveSettings,
  updateSettings,
} from "../../../services/apiservices/settings";
import {
  CommonConfirmationDialog,
  CommonSuccessDialog,
} from "../../../components/DialogComponent/SupplyDataDialog";
import { useNavigate } from "react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../../components/ui/card";
import { Clock, Archive, ArchiveX, CheckCircle } from "lucide-react";
import SupplyCategorysDetails from "./SupplyCategoryDetails";
import { useToast } from "../../../hooks/useToast";
import SingleSelectNew from "../../../components/SelectField/SingleSelectNew";
import MultiSelectWithCheckbox from "../../../components/SelectField/MulitpleSelectNew";

const SuppliePageSetting = () => {
  const [autoArchiveRequest, setAutoArchiveRequest] = useState("notAllowed");
  const [archiveRequestRole, setArchiveRequestRole] = useState([]);
  const [approveRequestRole, setApproveRequestRole] = useState([]);
  const [intervalTimeOfClothing, setIntervalTimeOfClothing] = useState({
    days: 0,
    months: 0,
    years: 0,
  });
  const [parentCategories, setParentCategories] = useState([]);
  const [categoriesItems, setCategoriesItems] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [editItem, setEditItem] = useState(null);
  const [newItem, setNewItem] = useState({
    title: "",
    description: "",
    maxNumberAllowed: "",
    OrderPeriod: "",
  });
  const commonContext = useContext(CommonContext);
  const auth = useContext(AuthContext);
  const [error, setError] = useState({});
  const [data, setData] = useState();
  const [categoryIds, setCategoryIds] = useState([]);
  const [open, setOpen] = useState(false);
  const [updateOpen, setUpdateOpen] = useState(false);
  const [resetOpen, setResetOpen] = useState(false);
  const [resetSuccessOpen, setResetSuccessOpen] = useState(false);
  const [tab, setTab] = useState("settings");
  const navigate = useNavigate();
  const { toast } = useToast();
  const companyId =
    auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;
  const isMobile = useMediaQuery("(max-width:767px)");

  const autoArchiveOptions = [
    { label: "Not Allowed", value: "notAllowed" },
    { label: "15 Days", value: "15 Days" },
    { label: "30 Days", value: "30 Days" },
    { label: "60 Days", value: "60 Days" },
    { label: "90 Days", value: "90 Days" },
  ];

  const Roles = [
    { label: "ADMIN", value: "admin" },
    { label: "SUPPORT", value: "support" },
  ];

  const monthsOptions = generateNumberArray(1, 12);
  const daysOptions = generateNumberArray(1, 30);
  const yearsOptions = generateNumberArray(1, 2);

  const handleAutoRequestChange = (e) => {
    setAutoArchiveRequest(e);
  };

  const handleArchiveRequestRoleChange = (e) => {
    setArchiveRequestRole(e);
  };

  const handleApproveRequestRoleChange = (e) => {
    setApproveRequestRole(e);
  };

  const handleIntervalTimeOfClothing = (e) => {
    const { name, value } = e.target;
    setIntervalTimeOfClothing((prev) => ({
      ...prev,
      [name]: Number(value),
    }));
  };


  const fetchSettings = async () => {
    try {
      commonContext.setLoader(true);

      await Promise.all([
        getSuppliesCompanyCategories((categoriesData) => {
          const parentCategoriesCompanyData = categoriesData?.filter(
            (item) =>
              !item.parentCategoryId &&
              item.companyId === companyId &&
              !item.deleted
          );
          const childCategoriesCompanyData = categoriesData?.filter(
            (item) =>
              item.parentCategoryId &&
              item.companyId === companyId &&
              !item.deleted
          );

          setParentCategories(sortingFunction(parentCategoriesCompanyData));
          setCategoriesItems(sortingFunction(childCategoriesCompanyData));

          const allCategoryIds = categoriesData?.map((item) => item.id);
          setCategoryIds(allCategoryIds);
        }),

        getSettings("supplie_settings", (res) => {
          if (res?.data) {
            const filteredData = res?.data?.filter(
              (item) => item?.companyId === companyId && !item.deleted
            );

            if (filteredData.length > 0) {
              const [firstItem] = filteredData;
              setData(filteredData);
              setAutoArchiveRequest(firstItem?.autoArchiveRequest || "notAllowed");
              setArchiveRequestRole(firstItem?.archiveRequestRole);
              setApproveRequestRole(firstItem?.approveRequestRole);
              setIntervalTimeOfClothing({
                days: firstItem?.intervalTimeOfClothing?.days,
                months: firstItem?.intervalTimeOfClothing?.months,
                years: firstItem?.intervalTimeOfClothing?.years,
              });
            } else {
              setData();
              setAutoArchiveRequest("notAllowed");
              setArchiveRequestRole([]);
              setApproveRequestRole([]);
              setIntervalTimeOfClothing({});
            }
          } else {
            setData();
            setAutoArchiveRequest("notAllowed");
            setArchiveRequestRole([]);
            setApproveRequestRole([]);
            setIntervalTimeOfClothing({});
          }
        }),
      ]);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      commonContext.setLoader(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const sortingFunction = (data) => {
    const result = data.sort((a, b) => {
      if (a.orders < b.orders) return -1;
      if (a.orders > b.orders) return 1;

      return 0;
    });

    return result;
  };

  const handleAddCategory = () => {
    if (newCategory.trim()) {
      const newCategoryId = generateFirebaseId(categoryIds);
      const currentCategories = Array.isArray(parentCategories)
        ? parentCategories
        : [];

      const updatedCategories = [
        ...currentCategories,
        {
          id: newCategoryId,
          orders: currentCategories.length + 1,
          companyId: companyId,
          title: newCategory,
          status: true,
          description: "",
          isUpdated: true,
        },
      ];

      const recalculateOrders = updatedCategories.map((category, index) => ({
        ...category,
        orders: index + 1,
      }));

      setParentCategories(recalculateOrders);
      setNewCategory("");
    }
  };

  const handleAddItem = (categoryId) => {
    const currentNewItem = newItem[categoryId];
    if (currentNewItem?.title?.trim()) {
      const newItemId = generateFirebaseId(categoryIds);

      setCategoriesItems((prev) => {
        const updatedItems = [
          ...prev,
          {
            id: newItemId,
            orders:
              prev.filter((item) => item.parentCategoryId === categoryId)
                .length + 1,
            companyId: companyId,
            title: currentNewItem.title,
            description: currentNewItem.description,
            status: true,
            parentCategoryId: categoryId,
            ...(currentNewItem?.maxNumberAllowed && {
              maxNumberAllowed: currentNewItem.maxNumberAllowed,
            }),
            ...(currentNewItem?.OrderPeriod && {
              OrderPeriod: currentNewItem.OrderPeriod,
            }),
            isUpdated: true,
          },
        ];
        return recalculateOrders(updatedItems);
      });

      setNewItem((prev) => ({
        ...prev,
        [categoryId]: {
          title: "",
          description: "",
        },
      }));
    }
  };

  const handleRemoveItem = (itemId) => {
    setCategoriesItems((prev) => {
      const updatedItems = prev.map((item) =>
        item.id === itemId
          ? { ...item, deleted: true, status: false, isUpdated: true }
          : item
      );
      return recalculateOrders(updatedItems);
    });
  };

  const handleSaveEdit = () => {
    setCategoriesItems((prev) => {
      const updatedItems = prev.map((item) =>
        item.id === editItem.itemId
          ? { ...item, ...editItem, isUpdated: true }
          : item
      );
      return recalculateOrders(updatedItems);
    });

    setEditItem(null);
  };

  const handleRemoveCategory = (categoryId) => {
    const updatedCategories = parentCategories?.map((category) =>
      category.id === categoryId
        ? { ...category, deleted: true, status: false, isUpdated: true }
        : category
    );

    const activeCategories = updatedCategories?.filter(
      (category) => !category.deleted
    );
    const reorderedActiveCategories = activeCategories?.map(
      (category, index) => ({
        ...category,
        orders: index + 1,
      })
    );

    const removedCategories = updatedCategories?.filter(
      (category) => category.deleted
    );
    const finalCategories = [
      ...reorderedActiveCategories,
      ...removedCategories,
    ];
    setParentCategories(finalCategories);

    const updatedItems = categoriesItems?.map((item) =>
      item.parentCategoryId === categoryId
        ? { ...item, deleted: true, status: false, isUpdated: true }
        : item
    );
    setCategoriesItems(updatedItems);
  };

  const getCategoryItems = (categoryId) => {
    return categoriesItems?.filter(
      (item) => item?.parentCategoryId === categoryId && item?.deleted !== true
    );
  };

  const validFields = () => {
    const errormessages = {};
    let isValid = true;

    if (!autoArchiveRequest && (!archiveRequestRole.length || archiveRequestRole.length === 0) && (!approveRequestRole.length || approveRequestRole.length === 0)) {
      isValid = false;
      errormessages.autoArchiveRequest = "Auto Archive Request is Required";
      errormessages.archiveRequestRole = "Archive Request Role is Required";
      errormessages.approveRequestRole = "Approve Request Role is Required";
    }

    setError(errormessages);
    return isValid;
  };

  const recalculateOrders = (categoriesItems) => {
    const activeItems = categoriesItems?.filter((item) => !item.deleted);

    const groupedItems = activeItems?.reduce((acc, item) => {
      const { parentCategoryId } = item;
      acc[parentCategoryId] = acc[parentCategoryId] || [];
      acc[parentCategoryId].push(item);
      return acc;
    }, {});

    const updatedItems = Object.values(groupedItems).flatMap((items) =>
      items
        ?.sort((a, b) => a.orders - b.orders)
        ?.map((item, index) => ({
          ...item,
          orders: index + 1,
        }))
    );

    const removedItems = categoriesItems?.filter((item) => item.deleted);
    return [...updatedItems, ...removedItems];
  };

  const handleSaveData = async () => {
    try {
      commonContext?.setLoader(true);

      // if (!validFields()) return;

      const safeIntervalTime = {
        days: intervalTimeOfClothing?.days || 0,
        months: intervalTimeOfClothing?.months || 0,
        years: intervalTimeOfClothing?.years || 0,
      };

      const filterParentData =
        parentCategories
          ?.filter((item) => item.isUpdated)
          .map(({ isUpdated, ...rest }) => rest) || [];
      const filterChildData =
        categoriesItems
          ?.filter((item) => item.isUpdated)
          .map(({ isUpdated, ...rest }) => rest) || [];
      const data1 = [...filterParentData, ...filterChildData];

      const dataToSave = {
        autoArchiveRequest,
        archiveRequestRole,
        approveRequestRole,
        intervalTimeOfClothing: safeIntervalTime,
        companyId,
      };

      const [settingsData, categoriesData] = await Promise.all([
        saveSettings(dataToSave, "supplie_settings"),
        data1.length > 0
          ? saveOrUpdateSuppliesCompanyCategories(data1)
          : { status: true },
      ]);

      if (settingsData.status && categoriesData.status) {
        await fetchSettings();
        toast?.({ title: "Success", description: "Setting Saved Successfully" });
      }
    } catch (error) {
      console.error("Error saving data:", error);
    } finally {
      commonContext?.setLoader(false);
    }
  };

  const handleUpdateData = async () => {
    try {
      commonContext?.setLoader(true);

      // if (!validFields()) return;

      const safeIntervalTime = {
        days: intervalTimeOfClothing?.days || 0,
        months: intervalTimeOfClothing?.months || 0,
        years: intervalTimeOfClothing?.years || 0,
      };

      const filterParentData =
        parentCategories
          ?.filter((item) => item.isUpdated)
          .map(({ isUpdated, ...rest }) => rest) || [];
      const filterChildData =
        categoriesItems
          ?.filter((item) => item.isUpdated)
          .map(({ isUpdated, ...rest }) => rest) || [];
      const data1 = [...filterParentData, ...filterChildData];

      const dataToSave = {
        autoArchiveRequest,
        archiveRequestRole,
        approveRequestRole,
        intervalTimeOfClothing: safeIntervalTime,
        companyId,
      };

      const id = data[0]?.id || null;

      const [settingsData, categoriesData] = await Promise.all([
        updateSettings(dataToSave, "supplie_settings", id),
        data1.length > 0
          ? saveOrUpdateSuppliesCompanyCategories(data1)
          : { status: true },
      ]);

      if (settingsData.status && categoriesData.status) {
        await fetchSettings();
        toast?.({ title: "Success", description: "Setting Update Successfully" });
      }
    } catch (error) {
      console.error("Error updating data:", error);
    } finally {
      commonContext?.setLoader(false);
    }
  };

  const handleResetConfirm = async () => {
    setResetOpen(false);
    commonContext?.setLoader(true);

    const id = data[0]?.id;

    try {
      const [details, suppliesData] = await Promise.all([
        resetSettings("supplie_settings", id),
        resetSuppliesCompanyCategory(companyId),
      ]);

      if (details.status === true && suppliesData.status === true) {
        await fetchSettings();
        toast?.({ title: "Success", description: "Setting Reset Successfully" });
        commonContext?.setLoader(false);
      }

      commonContext?.setLoader(false);
    } catch (error) {
      console.error("Error resetting settings or supplies:", error);
      commonContext?.setLoader(false);
    }
  };

  const handleResetClose = () => {
    setResetOpen(false);
  };

  const handleResetSuccessClose = () => {
    setResetSuccessOpen(false);
    fetchSettings();
    toast?.({ title: "Success", description: "Setting Reset Successfully" });
  };

  const handleColse = () => {
    setOpen(false);
    navigate("/account/settings");
    toast?.({ title: "Success", description: "Setting Saved Successfully" });
  };

  const handleUpdateClose = () => {
    setUpdateOpen(false);
    navigate("/account/settings");
    toast?.({ title: "Success", description: "Setting Update Successfully" });
  };

  const handleReset = () => {
    if (data) {
      setResetOpen(true);
    } else {
      setData();
      setAutoArchiveRequest("notAllowed");
      setArchiveRequestRole([]);
      setApproveRequestRole([]);
      setIntervalTimeOfClothing({});
      setError({});
    }
  };

  const supplyCategoryPros = {
    styles,
    isMobile,
    handleRemoveCategory,
    handleRemoveItem,
    getCategoryItems,
    parentCategories,
    handleAddCategory,
    handleAddItem,
    newCategory,
    setNewCategory,
    newItem,
    setNewItem,
    handleSaveEdit,
    setEditItem,
    editItem,
  };

  return (
    <>
      <Container>
        <PageTitle
          pageTitle={`Supplie Settings`}
          showBreadcrumb={[
            { label: "Home", to: "/" },
            { label: "Settings", to: "/account/settings" },
          ]}
          BreadCrumbCurrentPageTitle={"Supplie"}
          showLastSeen={true}
        />
        <div className={isMobile ? "pv-20 ph-15" : "pv-24 ph-32"}>
          <div className="mb-35">
            <div
              className="pv-5 ph-3 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] bg-[#F1F5F9]"
              style={{ width: "190px" }}
            >
              <Button
                className={`mr-10 ${tab === "settings" ? "bg-white dark:bg-gray-600 dark:text-white" : "dark:bg-[#1A1F2C] dark:text-white"}`}
                onClick={() => setTab("settings")}
                // style={{ backgroundColor: tab === "settings" ? "white" : "" }}
              >
                Settings
              </Button>
              <Button
                className={`${tab === "category" ? "bg-white dark:bg-gray-600 dark:text-white" : "dark:bg-[#1A1F2C] dark:text-white"}`}
                onClick={() => setTab("category")}
                // style={{ backgroundColor: tab === "category" ? "white" : "" }}
              >
                Categories
              </Button>
            </div>
          </div>
          {tab === "settings" && (
            <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2">
              <Card className="bg-white dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
                <CardHeader className="pb-12 pt-24 ph-24">
                  <div className="flex items-center space-x-2">
                    <div className="p-2 bg-blue-50 rounded-md dark:bg-gray-800">
                      <Archive className="h-5 w-5 text-blue-500 dark:text-blue-400" />
                    </div>
                    <CardTitle>Auto Archive Request</CardTitle>
                  </div>
                  <CardDescription style={{ color: "#64748B" }}>
                    Configure automatic archiving of supply requests
                  </CardDescription>
                </CardHeader>
                <CardContent className="pt-0 pb-24 ph-24">
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                    className="mv-10"
                  >
                    Auto Archive Period
                  </p>
                  <SingleSelectNew
                    contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                    itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                    value={autoArchiveRequest}
                    name={"autoArchiveRequest"}
                    onChange={handleAutoRequestChange}
                    options={autoArchiveOptions}
                  />
                  {error.autoArchiveRequest && (
                    <span className="d-flex small error color-danger">
                      {error.autoArchiveRequest}
                    </span>
                  )}

                  <p
                    style={{ color: "#64748B", fontSize: "14px" }}
                    className="mt-8"
                  >
                    Automatically archive supplies requests that haven't been
                    updated after a specific period.
                  </p>
                </CardContent>
              </Card>
              <Card className="bg-white  dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
                <CardHeader className="pb-12 pt-24 ph-24">
                  <div className="flex items-center space-x-2">
                    <div className="p-2 bg-purple-50  rounded-md dark:bg-gray-800">
                      <ArchiveX className="h-5 w-5 text-purple-500 dark:text-purple-400" />
                    </div>
                    <CardTitle>Archive Request Role</CardTitle>
                  </div>
                  <CardDescription style={{ color: "#64748B" }}>
                    Define which roles can archive supply requests
                  </CardDescription>
                </CardHeader>
                <CardContent className="pt-0 pb-24 ph-24">
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                    className="mv-10"
                  >
                    Archive Permission Role
                  </p>
                  <MultiSelectWithCheckbox
                    value={archiveRequestRole}
                    name={"archiveRequestRole"}
                    onChange={(e) => handleArchiveRequestRoleChange(e)}
                    options={Roles}
                    selectAllOption={true}
                    supplies={true}
                  />
                  {error.archiveRequestRole && (
                    <span className="d-flex small error color-danger">
                      {error.archiveRequestRole}
                    </span>
                  )}
                  <p
                    style={{ color: "#64748B", fontSize: "14px" }}
                    className="mt-8"
                  >
                    Define which roles have permission to archive supplies
                    requests.
                  </p>
                </CardContent>
              </Card>
              <Card className="bg-white  dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
                <CardHeader className="pb-12 pt-24 ph-24">
                  <div className="flex items-center space-x-2">
                    <div className="p-2 bg-green-50  rounded-md dark:bg-gray-800">
                      <CheckCircle className="h-5 w-5 text-green-500 dark:text-green-400" />
                    </div>
                    <CardTitle>Approve Request Role</CardTitle>
                  </div>
                  <CardDescription style={{ color: "#64748B" }}>
                    Define which roles can approve supply requests
                  </CardDescription>
                </CardHeader>
                <CardContent className="pt-0 pb-24 ph-24">
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                    className="mv-10"
                  >
                    Approval Permission Role
                  </p>
                  <MultiSelectWithCheckbox
                    value={approveRequestRole}
                    name={"approveRequestRole"}
                    onChange={(e) => handleApproveRequestRoleChange(e)}
                    options={Roles}
                    selectAllOption={true}
                    supplies={true}
                  />
                  {error.approveRequestRole && (
                    <span className="d-flex small error color-danger">
                      {error.approveRequestRole}
                    </span>
                  )}
                  <p
                    style={{ color: "#64748B", fontSize: "14px" }}
                    className="mt-8"
                  >
                    Define which roles have permission to approve supplies
                    requests.
                  </p>
                </CardContent>
              </Card>

              <Card className="bg-white  dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
                <CardHeader className="pb-12 pt-24 ph-24">
                  <div className="flex items-center space-x-2">
                    <div className="p-2 bg-amber-50 rounded-md dark:bg-gray-800">
                      <Clock className="h-5 w-5 text-amber-500 dark:text-amber-400" />
                    </div>
                    <CardTitle>Interval Time of Clothing</CardTitle>
                  </div>
                  <CardDescription style={{ color: "#64748B" }}>
                    Set the interval time for ordering company clothing
                  </CardDescription>
                </CardHeader>
                <CardContent className="pt-0 pb-24 ph-24">
                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <p
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                        className="mv-10"
                      >
                        Days
                      </p>
                      <select
                        value={intervalTimeOfClothing?.days || ""}
                        onChange={handleIntervalTimeOfClothing}
                        name={"days"}
                        className={`${styles.selectIntervalTime} bg-white text-black dark:bg-[#1A1F2C] dark:text-white border border-gray-300 dark:border-gray-600 rounded px-2 py-1`}
                      >
                        <option value="" disabled>
                          {" "}
                          0{" "}
                        </option>
                        {daysOptions.map((day, index) => (
                          <option key={index} value={day}>
                            {day}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <p
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                        className="mv-10"
                      >
                        Months
                      </p>
                      <select
                        value={intervalTimeOfClothing?.months || ""}
                        onChange={handleIntervalTimeOfClothing}
                        name={"months"}
                        className={`${styles.selectIntervalTime} bg-white text-black dark:bg-[#1A1F2C] dark:text-white border border-gray-300 dark:border-gray-600 rounded px-2 py-1`}
                      >
                        {" "}
                        <option value="" disabled>
                          {" "}
                          0{" "}
                        </option>
                        {monthsOptions.map((month, index) => (
                          <option key={index} value={month}>
                            {month}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <p
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                        className="mv-10"
                      >
                        Years
                      </p>
                      <select
                        value={intervalTimeOfClothing?.years || ""}
                        onChange={handleIntervalTimeOfClothing}
                        name={"years"}
                        className={`${styles.selectIntervalTime} bg-white text-black dark:bg-[#1A1F2C] dark:text-white border border-gray-300 dark:border-gray-600 rounded px-2 py-1`}
                      >
                        {" "}
                        <option value="" disabled>
                          {" "}
                          0{" "}
                        </option>
                        {yearsOptions.map((year, index) => (
                          <option key={index} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <p
                    style={{ color: "#64748B", fontSize: "14px" }}
                    className="mt-8"
                  >
                    Set the interval time for ordering company clothing and
                    other supplies.
                  </p>
                </CardContent>
              </Card>
            </div>
          )}
          {tab === "category" && (
            <SupplyCategorysDetails supplyCategoryPros={supplyCategoryPros} />
          )}
          <div className="mv-15">
            <Button
              variant="contained"
              style={{
                boxShadow: "none",
                backgroundColor: "#078037",
                color: "white",
              }}
              onClick={data ? handleUpdateData : handleSaveData}
            >
              {data ? "Update Changes" : "Save Changes"}
            </Button>
            {/* <Button
              variant="outlined"
              color="secondary"
              style={{ marginLeft: 10, boxShadow: "none" }}
              onClick={handleReset}
            >
              Reset
            </Button> */}
            <Button
              variant="outlined"
              className="dark:text-white"
              style={{ marginLeft: 10, boxShadow: "none"}}
              onClick={() => navigate("/account/settings")}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Container>
      {open && 
      <CommonSuccessDialog 
        open={open} 
        onClose={handleColse} 
        title={"Success"}
        message={"Your settings have been successfully saved."}
      />}
      {updateOpen && (
        <CommonSuccessDialog 
        open={updateOpen} 
        onClose={handleUpdateClose} 
        title={"Success"}
        message={"Your settings have been successfully update."}
        />
      )}
      {resetOpen && (
        <CommonConfirmationDialog
          open={resetOpen}
          onConfirm={handleResetConfirm}
          onClose={handleResetClose}
          title={"Setting Reset"}
          message={"Are you sure you want to reset the settings?"}
          buttonTitle={"Yes"}
        />
      )}
      {resetSuccessOpen && (
        <CommonSuccessDialog
          open={resetSuccessOpen}
          onClose={handleResetSuccessClose}
          title={"Success"}
          message={"Your settings have been successfully reset."}
        />
      )}
    </>
  );
};

export default SuppliePageSetting;
